@if (about && about.visible) {
<p>
  {{ about.value }}
</p>
}
<ul [ngClass]="class">
  @if (address && address.visible) {
  <li>
    @if (icon) {
    <i class="ri-map-pin-line"></i>
    }
    {{ address.value }}
  </li>
  }
  @if (phone && phone.visible) {
  <li>
    @if (icon) {
    <i class="ri-phone-line"></i>
    }
    {{ "call_us" | translate }}: {{ phone.value }}
  </li>
  }
  @if (email && email.visible) {
  <li>
    @if (icon) {
    <i class="ri-mail-line"></i>
    }
    {{ "email_us" | translate }}: {{ email.value }}
  </li>
  }
</ul>